export const SET_UN_REGISTER_RIDER_LOADING = "SET_UN_REGISTER_RIDER_LOADING";
export const SET_UN_REGISTER_RIDER_DATA = "SET_UN_REGISTER_RIDER_DATA";
export const SET_UN_REGISTER_RIDER_PAGINATION = "SET_UN_REGISTER_RIDER_PAGINATION";
export const SET_UN_REGISTER_RIDER_DETAIL_DATA = "SET_UN_REGISTER_RIDER_DETAIL_DATA";
export const SET_UN_REGISTER_RIDER_FILTER = "SET_UN_REGISTER_RIDER_FILTER";
export const RESET_UN_REGISTER_RIDER_REDUCER = "RESET_UN_REGISTER_RIDER_REDUCER";